// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"381d1279ebaad0f20545","682":"246fdadf7fde49f2e46b","731":"c630501e759cb3f06436","843":"cff4afe7cadcd319a1bf","883":"7a4778cfc4a5c25b098c"}[chunkId] + ".js";
};